import React from "react";
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogFooter,
    DialogTitle,
    PageLevelAlert,
    Button,
} from "@kuda/ui";

const SEVERITY_TO_ALERT_TYPE = {
    error: "error",
    warning: "warning",
    info: "info",
    success: "success",
};

const Dialogbox = ({ open, onClose, title, severity, message, onConfirm, confirmText = "Confirm", closeText = "Close", loading = false }) => {
    return (
        <Dialog open={open} onOpenChange={(next) => { if (!next) onClose(); }}>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>{title}</DialogTitle>
                </DialogHeader>
                <PageLevelAlert type={SEVERITY_TO_ALERT_TYPE[severity] || "info"} width="100%">
                    {message}
                </PageLevelAlert>
                <DialogFooter>
                    <Button variant="text" onClick={onClose} disabled={loading}>{closeText}</Button>
                    {onConfirm && (
                        <Button variant="filled" onClick={onConfirm} loading={loading} disabled={loading}>{confirmText}</Button>
                    )}
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};

export default Dialogbox;
